import React, { useMemo } from 'react';
import { number } from 'prop-types';
import Skeleton from 'react-loading-skeleton';

const ListingLoader = ({ count = 3 }) => {
    const skeletonItems = useMemo(() => {
        const items = [];

        if (!count) {
            return items;
        }

        for (let i = 0; i < count; i += 1) {
            items.push(
                <div className="col-md-4" key={i}>
                    <Skeleton
                        height={18}
                        style={{
                            marginBottom: 15
                        }}
                    />
                    <Skeleton
                        height={18}
                        width="90%"
                        style={{
                            marginBottom: 30
                        }}
                    />

                    <div className="skeleton-flex-container">
                        <Skeleton height={10} width={80} />
                        <Skeleton height={10} width={80} />
                    </div>
                </div>
            );
        }

        return items;
    }, []);

    return (
        <div className="grid grid--cards grid--cards--large-v-gutter">
            {skeletonItems.map(item => item)}
        </div>
    );
};

ListingLoader.propTypes = {
    count: number
};

export default ListingLoader;
